module.exports = __webpack_public_path__ + "img/politics-explained-logo.7fbd811f.svg";